const SAMPLE_GEOMETRY = {
    type: "MultiPolygon",
    coordinates: [
        [
            [
                [30.0, 60.0],
                [31.0, 60.0],
                [31.0, 59.0],
                [30.0, 59.0],
                [30.0, 60.0],
            ],
        ],
        [
            [
                [32.0, 60.0],
                [33.0, 60.0],
                [33.0, 59.0],
                [32.0, 59.0],
                [32.0, 60.0],
            ],
            [
                [32.2, 59.8],
                [32.8, 59.8],
                [32.8, 59.2],
                [32.2, 59.2],
                [32.2, 59.8],
            ],
        ],
    ],
};

const STUB_ZONES = [
    { id: 1, name: "Москва — центр", type_id: 11 },
    { id: 2, name: "Санкт-Петербург", type_id: 11 },
    { id: 3, name: "Казань", type_id: 11 },
    { id: 4, name: "Нижний Новгород", type_id: 11 },
];

const delay = (value, ms = 300) => new Promise((resolve) => setTimeout(() => resolve(value), ms));

class ZonesApiStub {
    async list({ name } = {}) {
        let items = STUB_ZONES;
        if (name) {
            const q = name.toLowerCase();
            items = items.filter((z) => z.name.toLowerCase().includes(q));
        }
        return delay({ items, total_count: items.length });
    }

    async search(params = {}) {
        return this.list(params);
    }

    async getById(id) {
        const base =
            STUB_ZONES.find((z) => String(z.id) === String(id)) || { id, name: `Зона ${id}`, type_id: 11 };
        return delay({ ...base, geometry: SAMPLE_GEOMETRY });
    }

    async create(data) {
        return delay({ id: STUB_ZONES.length + 1, type_id: 11, ...data });
    }

    async regions() {
        return delay({ items: [], total_count: 0 });
    }

    async update(id, data) {
        return delay({ id, ...data });
    }

    async remove(id) {
        return delay({ id });
    }
}

export default ZonesApiStub;
